var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"type":"flex","justify":"space-between","align":"middle"}},[_c('i',{staticClass:"el-icon-back",on:{"click":_vm.handleUpdateCollapse}}),_c('div',{staticClass:"user"},[_vm._v("\n    "+_vm._s(_vm.realname)+"\n    "),_c('el-button',{attrs:{"size":"small","type":"danger"},on:{"click":_vm.handleLoout}},[_vm._v("退出")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }